/* tslint:disable */
/* eslint-disable */
/**
 * Fila12 API
 * Through this API you can access .
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ActivitySessionDateLookupDto,
    ActivitySessionDateLookupDtoFromJSON,
    ActivitySessionDateLookupDtoFromJSONTyped,
    ActivitySessionDateLookupDtoToJSON,
    CustomError,
    CustomErrorFromJSON,
    CustomErrorFromJSONTyped,
    CustomErrorToJSON,
} from './';

/**
 * The response with a list of objects of type "T".
 * @export
 * @interface ActivitySessionDateLookupDtoResponseListViewModel
 */
export interface ActivitySessionDateLookupDtoResponseListViewModel {
    /**
     * Gets the list of errors.
     * @type {Array<CustomError>}
     * @memberof ActivitySessionDateLookupDtoResponseListViewModel
     */
    readonly errors?: Array<CustomError> | null;
    /**
     * Gets or sets the list of objects.
     * @type {Array<ActivitySessionDateLookupDto>}
     * @memberof ActivitySessionDateLookupDtoResponseListViewModel
     */
    data?: Array<ActivitySessionDateLookupDto> | null;
}

export function ActivitySessionDateLookupDtoResponseListViewModelFromJSON(json: any): ActivitySessionDateLookupDtoResponseListViewModel {
    return ActivitySessionDateLookupDtoResponseListViewModelFromJSONTyped(json, false);
}

export function ActivitySessionDateLookupDtoResponseListViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivitySessionDateLookupDtoResponseListViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(CustomErrorFromJSON)),
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(ActivitySessionDateLookupDtoFromJSON)),
    };
}

export function ActivitySessionDateLookupDtoResponseListViewModelToJSON(value?: ActivitySessionDateLookupDtoResponseListViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(ActivitySessionDateLookupDtoToJSON)),
    };
}


